import React, {useRef , useState} from 'react';
import { Form, Field } from 'react-final-form';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { classNames } from 'primereact/utils';
import { Toast } from 'primereact/toast';
import { useService } from '../../Context/ServiceContext';
import { useActif } from '../../Context/ActifContext';
import { contacterService } from '../../Data/typeService_service';
import FileUploader from '../NousContacter/FileUploader.jsx'
import "../NousContacter/FileUploader.css"
export default function NousContacter({ setDialog }) {
    const {selectedService}=useService()
    const{selectedActif}=useActif()
    const [file, setFile] = useState(null);
    const nomService= selectedService.libelle
    const idActif= selectedActif.id_actif_gexpertise
    const toast = useRef(null);
    const [sending, setSending] = useState(false);
    const onSubmit = async (data) => {
        const ServiceId = selectedService.id_type_service_gexpertise;
        const formData = new FormData();
        formData.append("actifId", idActif)
        formData.append("objet", data.objet)
        formData.append("contenu", data.contenu)
        formData.append("file", file);
        try {
      setSending(true); // start spinner

      await contacterService(ServiceId, formData);

      // keep your existing toast behavior
      toast.current.show({
        severity: 'success',
        summary: 'succès ',
        detail: 'Votre demande a été envoyé avec succès',
        life: 3000
      });

      setTimeout(() => setDialog(false), 1000);
    } catch (error) {
      console.error(error);
    } finally {
      setSending(false); // stop spinner
    }
  };
    const validate = (data) => {
        let errors = {};

        if (!data.objet) {
            errors.objet = 'Ce champ est obligatoire.'
        }
        if (!data.contenu) {
            errors.contenu = 'Ce champ est obligatoire.'
        }

        return errors;
    };

    const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
    const getFormErrorMessage = (meta) => {
        return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
    };

    return (
        <>
             <Toast ref={toast} />
      
        <div className="toolBar_header">
            <Form onSubmit={onSubmit} initialValues={{ objet: `demande d'information sur le service : ${nomService}`, contenu: '' }} validate={validate} render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit} className="p-fluid">


                    <Field name="objet" render={({ input, meta }) => (
                        <div className="p-field">
                            <span className="p-float-label p-input-icon-right">

                                <InputText id="objet" {...input} autoFocus className={classNames({ 'p-invalid': isFormFieldValid(meta) })} />
                                <label htmlFor="objet" >Objet *</label>
                            </span>
                            {getFormErrorMessage(meta)}
                        </div>
                    )} />
                    <Field name="contenu" render={({ input, meta }) => (
                        <div className="p-field">
                            <span className="p-float-label p-input-icon-right">

                                <InputTextarea id="Contenu" {...input} className={classNames({ 'p-invalid': isFormFieldValid(meta) })} autoResize />
                                <label htmlFor="Contenu" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Écrivez ici *</label>
                            </span>
                            {getFormErrorMessage(meta)}
                        </div>
                    )} />
                      {/* <label className="fileInput">
                <Field
                  name="file"
                  render={({ input, meta }) => (
                    <div className="p-field">
                      <input
                        type="file"
                        id="file"
                        onChange={
                          (e) => setFile(e.target.files[0])
                          // console.log('fileee' , e.target.files[0])
                        }
                      />
                      {meta.error && meta.touched && <span>{meta.error}</span>}
                    </div>
                  )}
                />{" "}
                <i className="pi pi-cloud-upload" style={{ fontSize: "15px" }}>
                  {" "}
                </i>{" "}
                Joindre un fichier
              </label> */}
              <FileUploader
                onFileChange={(selectedFile) => setFile(selectedFile)}
                label="Joindre un fichier"
                maxSize={20} // 20 MB
              />
                    <div className='btnContact'>
                      
                        <Button
          type="submit"
          label={sending ? "Envoi..." : "Confirmer"}  // or keep "Confirmer"
          className="p-mt-2 send"
          loading={sending}     // <-- spinner shown here
          disabled={sending}    // optional: prevents double-clicks
          aria-busy={sending}   // accessibility
        />
                    </div>

                </form>
            )} />


        </div>
        </>
    )
}
